// extracted by mini-css-extract-plugin
export default {"store-wrapper":"YCCRY","store-qr":"dfdVH","store-image":"s52IF"};